import { ConfigProvider, Select } from "antd"
import { useRef, useEffect } from "react"

const Input = ({
    dir,
    label,
    name,
    type,
    placeholder,
    value,
    defaultValue,
    options,
    multi,
    onChange,
    required,
    disabled,
}) => {
    const hiddenInputRef = useRef(null)

    const theme = {
        components: {
            Select: {
                activeOutlineColor: "rgba(5,145,255,0.1)",
                optionSelectedColor: "#fff",
                colorBgContainer: "#083344",
                colorBorder: "#0369a1",
                optionSelectedBg: "#0ea5e9",
                multipleItemBg: "#0ea5e9",
                hoverBorderColor: "#0369a1",
                colorBgBase: "rgba(5,145,255,0.1)",
                colorBgElevated: "#083344",
            },
        },
    }

    // Initialize hidden input with defaultValue
    useEffect(() => {
        if (hiddenInputRef.current && defaultValue) {
            if (Array.isArray(defaultValue)) {
                hiddenInputRef.current.value = defaultValue.join(",")
            } else if (typeof defaultValue === "string") {
                hiddenInputRef.current.value = defaultValue
            }
        }
    }, [defaultValue])

    const handleSelectChange = (selectedValue) => {
        if (hiddenInputRef.current) {
            if (Array.isArray(selectedValue)) {
                hiddenInputRef.current.value = selectedValue.join(",")
            } else if (selectedValue !== null && selectedValue !== undefined) {
                hiddenInputRef.current.value = String(selectedValue)
            } else {
                hiddenInputRef.current.value = ""
            }

            // Dispatch change event
            const event = new Event("change", { bubbles: true })
            hiddenInputRef.current.dispatchEvent(event)
        }

        if (typeof onChange === "function") {
            onChange(selectedValue)
        }
    }

    return (
        <div>
            <label>{label}</label>
            {options ? (
                <ConfigProvider theme={theme}>
                    <Select
                        showSearch
                        mode={multi ? "multiple" : undefined}
                        id={name}
                        options={options}
                        direction={dir || "ltr"}
                        className="block h-8 w-full outline-none"
                        filterOption={(input, option) =>
                            (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        value={value}
                        optionFilterProp="value"
                        placeholder={placeholder}
                        defaultValue={
                            Array.isArray(defaultValue)
                                ? defaultValue
                                : typeof defaultValue == "string"
                                  ? defaultValue?.split(",").filter((v) => v) // Filter out empty strings
                                  : defaultValue
                        }
                        onChange={handleSelectChange}
                        disabled={disabled}
                        allowClear
                    />
                    <input
                        type="hidden"
                        name={name}
                        id={name + "-hidden"}
                        ref={hiddenInputRef}
                        defaultValue={Array.isArray(defaultValue) ? defaultValue.join(",") : defaultValue || ""}
                    />
                </ConfigProvider>
            ) : (
                <input
                    type={type || "text"}
                    dir={dir}
                    name={name}
                    id={name}
                    value={value}
                    className="styled-input"
                    onChange={onChange}
                    placeholder={placeholder}
                    defaultValue={defaultValue}
                    required={required}
                    disabled={disabled}
                />
            )}
        </div>
    )
}

export default Input
